// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3tVH_","header":"PatientQuestionnaire_header__2m9mR","info":"PatientQuestionnaire_info__p5CIF"};